// src/features/shipping/shippingSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Thunk to fetch shipments from your Django API
export const fetchShipments = createAsyncThunk(
  'shipping/fetchShipments',
  async (_, { rejectWithValue }) => {
    try {
      // If Django endpoint is /api/shipping or /api/shipments,
      // adjust the URL accordingly:
      const response = await axios.get('/api/shipping');
      return response.data; // Expect an array of shipping objects
    } catch (err) {
      return rejectWithValue(err.response?.data || 'Something went wrong');
    }
  }
);

const shippingSlice = createSlice({
  name: 'shipping',
  initialState: {
    loading: false,
    error: null,
    data: []
  },
  reducers: {
    // For create/update/delete shipping, you'd add more here if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchShipments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchShipments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload; // array of shipments
      })
      .addCase(fetchShipments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default shippingSlice.reducer;
